import { useEffect } from 'react';
import { Platform } from 'react-native';

/**
 * Shows a browser "are you sure you want to leave?" dialog
 * when the user tries to close/refresh the page with unsaved changes.
 *
 * @param hasUnsavedChanges - whether the form has unsaved data
 */
export function useUnsavedChangesWarning(hasUnsavedChanges: boolean): void {
  useEffect(() => {
    if (Platform.OS !== 'web' || typeof window === 'undefined') return;
    if (!hasUnsavedChanges) return;

    const handler = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      // Modern browsers ignore custom messages but still show the dialog
      e.returnValue = '';
    };

    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [hasUnsavedChanges]);
}
